// src/components/ClientSessionWrapper.tsx
"use client";

import React from "react";
import { SessionProvider as NextAuthSessionProvider } from "next-auth/react";
import { ZuSessionProvider } from "@/components/ZuSessionProvider";
import { Session } from "next-auth";

interface ClientSessionWrapperProps {
  session: Session | null; // Pass the server-fetched session
  children: React.ReactNode;
}

export const ClientSessionWrapper: React.FC<ClientSessionWrapperProps> = ({
  session,
  children,
}) => {
  return (
    <NextAuthSessionProvider session={session}>
      <ZuSessionProvider>{children}</ZuSessionProvider>
    </NextAuthSessionProvider>
  );
};